/* eslint-disable camelcase */

import type { QuestionTypes } from '.';

export type NextQuestionByAnswer = 'byOrder' | 'thankYou' | string;

export type NextQuestion = 'byAnswer' | NextQuestionByAnswer;

interface BaseSurveyQuestion {
  uuid: string;
  text: string;
  type: QuestionTypes;
  next: NextQuestion;
  required: boolean;
  nextIfSkipped?: string;
  deleted?: boolean;
  // used to send an image as base64 to the API
  image?: string;
  // paths to the stored image resources
  image_url?: string;
  image_thumbnail_url?: string;
}

export interface Label {
  text: string;
}

interface Answer {
  text: string;
  comments: boolean;
}

interface CloseEndedQuestion extends BaseSurveyQuestion {
  // eslint-disable-next-line camelcase
  randomize_answer_order: boolean;
  // eslint-disable-next-line camelcase
  pin_last_to_bottom: boolean;
  answers: Answer[];
  nextByAnswer?: NextQuestionByAnswer[];
}

interface RatingScaleQuestion extends BaseSurveyQuestion {
  scaleCount: number;
  labels: Label[];
}

export type ReactionStyle = 'default' | 'emoji' | 'smiley' | 'star';

export type ReactionScore = 1 | 2 | 3 | 4 | 5;
interface ReactionTypeQuestion extends BaseSurveyQuestion {
  reaction_style: ReactionStyle;
  labels: Label[];
}

export interface NetPromoterScoreQuestion extends BaseSurveyQuestion {
  type: QuestionTypes.NET_PROMOTER_SCORE;
  labels: Label[];
  nextByAnswer?: NextQuestion[];
}

export interface EmailQuestion extends BaseSurveyQuestion {
  type: QuestionTypes.EMAIL;
}

export interface MultipleCloseEndedQuestion extends CloseEndedQuestion {
  type: QuestionTypes.MULTIPLE_CLOSE_ENDED;
}

export interface SingleCloseEndedQuestion extends CloseEndedQuestion {
  type: QuestionTypes.SINGLE_CLOSE_ENDED;
}

export interface SingleOpenEndedMultiLineQuestion extends BaseSurveyQuestion {
  type: QuestionTypes.SINGLE_OPEN_ENDED_MULTI_LINE;
}

export interface SingleOpenEndedSingleLineQuestion extends BaseSurveyQuestion {
  type: QuestionTypes.SINGLE_OPEN_ENDED_SINGLE_LINE;
}

export interface TitleAndDescriptionQuestion extends BaseSurveyQuestion {
  type: QuestionTypes.TITLE_AND_DESCRIPTION;
}

export interface RatingScale5Question extends RatingScaleQuestion {
  type: QuestionTypes.RATING_SCALE_5;
  nextByAnswer?: NextQuestion[];
}

export interface RatingScale7Question extends RatingScaleQuestion {
  type: QuestionTypes.RATING_SCALE_7;
  nextByAnswer?: NextQuestion[];
}

export interface ReactionQuestion extends ReactionTypeQuestion {
  type: QuestionTypes.REACTION;
  nextByAnswer?: NextQuestion[];
}

export type SurveyQuestion =
  | NetPromoterScoreQuestion
  | EmailQuestion
  | MultipleCloseEndedQuestion
  | SingleCloseEndedQuestion
  | SingleOpenEndedMultiLineQuestion
  | SingleOpenEndedSingleLineQuestion
  | TitleAndDescriptionQuestion
  | RatingScale5Question
  | RatingScale7Question
  | ReactionQuestion;

export function truncateUuid(question: SurveyQuestion): string {
  return (question.uuid || '').substr(0, 8);
}
